module.exports = __webpack_public_path__ + "img/Nav_carrot inverted.e3623768.svg";